
import React from "react"
import { About } from "./Components/About";
import Navbar from "./Components/Navbar";


function App() {
	
	return (
		<div>
		<Navbar />
		<About  />
		
		</div>
	)
}

export default App;
